import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AlertasSeguridadComponent } from './listado/alertas-seguridad.component';
import { MapaAlertasSeguridadComponent } from './mapa/mapa-alertas-seguridad.component';

const routes: Routes = [
  { path: '', redirectTo: 'listado', pathMatch: 'full' },
  {
    path: 'listado',
    title: 'Alertas de seguridad',
    component: AlertasSeguridadComponent,
  },
  {
    path: 'mapa',
    title: 'Mapa de alertas de seguridad',
    component: MapaAlertasSeguridadComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AlertasSeguridadRoutingModule {}
